import { render, staticRenderFns } from "./vendor-detail.vue?vue&type=template&id=3abbac16&lang=pug"
import script from "./vendor-detail.vue?vue&type=script&lang=js"
export * from "./vendor-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports